import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../hooks/ThemeContext';
import '../styles/NewIndexPage.css';
import ProfileMenu from "../objects/ProfileMenu";

export const IndexHeader = ({
                              user, //User object
                              firstWait, //Whether user is loaded or not
                              upgradeRedirect="results"
                            }) => {
    const [currProfileOpen, setCurrProfileOpen] = useState(false);

    const {theme} = useTheme();

    const navigate = useNavigate();

    const currProfileRef = useRef(currProfileOpen);

    useEffect(() => {
        currProfileRef.current = currProfileOpen;
      }, [currProfileOpen]);

    return (<>
          <div onClick={() => {
            navigate("/index?noredir=1")
          }} style={{cursor: 'pointer'}}>
            <h1>Rezify <img src={theme.logo} alt="Logo" style={{'verticalAlign': 'middle', 'height': '43px', 'marginLeft': '10px'}} /> </h1>
          </div>
          <div className="top-links">
            { !firstWait && <div className="spinner"></div>}
            { !(user.id) && firstWait &&
              <button href="/login" className="login-button">Login</button>
            }
            { user.id && firstWait &&
                <ProfileMenu user={user} upgradeRedirect={upgradeRedirect} />
            }
            {user.id && user.plan !== "premium" && firstWait && <a href={"/plans?redirect=" + upgradeRedirect} className='upgrade-button'>Upgrade</a>}
            {user.id && user.plan === "premium" && user.stripe_meta && user.stripe_meta.subscription_to_be_cancelled && firstWait && <a href={"/profile"} className='upgrade-button'>Reactivate</a>}

              <div className="top-right-link">
                  <a href="/feedback">Feedback Form</a>
              </div>

              <div className="top-right-link">
                  <a href="/help">Help</a>
              </div>
          </div>
    </>);
};